module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage Rtable4"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-4：经营场所情况表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "editArea editBox"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所有权",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.placeSituation, 'C002', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "场所情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.placePower, 'C020', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placeArea",
      "width": "150",
      "label": "占地面积（平米）",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value!==''"
    }]
  }, [_c('p', [_vm._v("历史版本：")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyJsonParams,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所有权",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.placeSituation, 'C002', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "场所情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.placePower, 'C020', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placeArea",
      "width": "150",
      "label": "占地面积（平米）",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value!==''"
    }],
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])]), _vm._v(" "), (_vm.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.seekPms.no,
      "layout": "prev, pager, next",
      "page-count": _vm.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bdb5fa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceTab/table4.vue
// module id = 1716
// module chunks = 1